import { render, staticRenderFns } from "./UserRevokeModal.vue?vue&type=template&id=e8bc7394&scoped=true&"
import script from "./UserRevokeModal.vue?vue&type=script&lang=ts&"
export * from "./UserRevokeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bc7394",
  null
  
)

export default component.exports